export default __webpack_public_path__ + "static/media/job_offer8_m.8da7e375.jpg";